var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',_vm._l((_vm.items),function(item){return _c('OptionCard',{key:item.title,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }